import { useCallback as u } from "react";
import { usePLMapboxStoreV2 as o } from "./index.es6.js";
import f from "./index.es240.js";
const g = () => u(
  ({ mapId: t, popupData: i, popupId: e }) => {
    var s, r, a, p;
    if (!((r = (s = o.getState().maps) == null ? void 0 : s[t]) == null ? void 0 : r.mapRef))
      return console.warn(`Map with ID "${t}" is not initialized yet`), null;
    e || (e = f());
    const n = ((p = (a = o.getState().maps) == null ? void 0 : a[t]) == null ? void 0 : p.popups) ?? {};
    return o.getState().actions.setMapPopups({
      mapId: t,
      popups: {
        ...n,
        [e]: i
      }
    }), e;
  },
  []
);
export {
  g as useAddPopup
};
//# sourceMappingURL=index.es49.js.map
